import React, {useContext, useState, useEffect} from 'react';
import {NavLink} from 'react-router-dom';

import {AuthContext} from '../../context';
import NavbarDropdown from './NavbarDropdown';

const NavbarList = ({menu}) => {
  const {user} = useContext(AuthContext);
  const [archivedAccounts, setArchivedAccounts] = useState([]);

  const getPathname = (el) => {
    if (user.infos.role === 'CUSTOMER') {
      return {pathname: `/service/${el._id}`, state: {service: el}};
    } else {
      return {pathname: `/admin/entreprise/${el._id}`};
    }
  };

  useEffect(() => {
    setArchivedAccounts(menu.filter((company) => company.isArchived));
  }, []);

  if (menu.length === 0)
    return <p className="navbar-list-container">Pas d&apos;entreprise enregistrée</p>;

  return (
    <ul className="navbar-list-container">
      {user.infos.role === 'CUSTOMER'
        ? menu.map((el) => (
            <li key={el._id} className="navbar-list-item">
              <NavLink
                className="navbar-list-link-customer"
                activeStyle={{
                  color: '#F9E7D4',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                }}
                to={getPathname(el)}
              >
                {el.name}
              </NavLink>
            </li>
          ))
        : menu
            .filter((el) => !el.isArchived)
            .map((el) => (
              <li key={el._id} className="navbar-list-item">
                <NavLink
                  className="navbar-list-link"
                  activeStyle={{
                    color: '#09092D',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                  }}
                  to={getPathname(el)}
                >
                  {el.name}
                </NavLink>
              </li>
            ))}
      {user.infos.role === 'ADMIN' && <NavbarDropdown companies={archivedAccounts} />}
    </ul>
  );
};

export default NavbarList;
